<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css">
<div class="d-flex flex-center flex-column flex-column-fluid">
  <mat-card class="login-container  inner-card-section ">
    <div class="inner-card-header">
      <h3 class="opacity_text mb-0 me-2">{{'login.newPassword' | translate}}</h3>
    </div>
    <form  [formGroup]="passwordResetForm">
      <div *ngIf="loaded" class="d-flex justify-content-between option-menu">
        <div *ngIf="!tokenValid" class="invalid-alert alert-msg w-100  mt-3">
          <div class="danger-svg gap-3">
              <i class="bi bi-exclamation-triangle" style="font-size: 35px; color: currentColor;"></i>
              {{ errorMsg }}
          </div>
        </div>

        <div *ngIf="tokenValid" class="d-flex flex-column w-100">
          <div class="mb-3 mt-3 d-flex flex-column align-items-start opacity_text">
            <label class="form-label w-100 text-start ">{{'stepperForm.personalInfo.email' | translate}} </label>
            <input  class="form-control " placeholder="{{'stepperForm.personalInfo.email' | translate}}" formControlName="email" autocomplete="email" readonly>
          </div>
          <div class="mb-4">
            <div class="input-group">
              <label class=" opacity_text form-label w-100 text-start ">{{'shared.verifyPassword' | translate}} </label>
              <input
                type="{{ hidePS1 ? 'password' : 'text' }}"
                class="form-control opacity_text"
                id="password"
                formControlName="password"
                placeholder="{{ 'shared.verifyPassword' | translate }}"
                autocomplete="new-password"
                [ngClass]="{'border border-danger':passwordResetForm.get('password')?.touched &&passwordResetForm.get('password')?.invalid}" />
              <button
                class="btn btn-outline-secondary opacity_text"
                type="button"
                (click)="toggleHidePassword('PS1')"
              >
                <i class="bi" [ngClass]="hidePS2 ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            <div *ngIf="passwordResetForm.get('password')?.touched && passwordResetForm.get('password')?.invalid && passwordResetForm.get('password').value.length > 0 "
                 class="text-danger mt-1 text-start d-flex align-items-center">
              <i class="bi bi-exclamation-circle-fill me-2"></i>
              {{ 'shared.passwordErrorForm' | translate }}
            </div>
          </div>

          <div class="mb-4">
            <div class="input-group">
              <label class=" opacity_text form-label w-100 text-start ">{{'shared.verifyPassword' | translate}} </label>
              <input
                type="{{ hidePS2 ? 'password' : 'text' }}"
                class="form-control opacity_text"
                id="verifyPassword"
                formControlName="verifyPassword"
                placeholder="{{ 'shared.verifyPassword' | translate }}"
                autocomplete="new-password"
                [ngClass]="{'border border-danger':passwordResetForm.get('verifyPassword')?.touched &&passwordResetForm.get('verifyPassword')?.invalid}" />
              <button
                class="btn btn-outline-secondary opacity_text"
                type="button"
                (click)="toggleHidePassword('PS2')"
              >
                <i class="bi" [ngClass]="hidePS2 ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            <div *ngIf="passwordResetForm.get('verifyPassword')?.touched && passwordResetForm.get('verifyPassword')?.invalid"
                 class="text-danger mt-1 text-start d-flex align-items-center">
              <i class="bi bi-exclamation-circle-fill me-2"></i>
              {{'shared.verifyPasswordErrorMatch' | translate}}
            </div>
          </div>
          <button mat-button class="p-btn-primary" [disabled]="!passwordResetForm.touched || passwordResetForm.invalid"
                  (click)="submit()">{{'shared.submit' | translate}}</button>
        </div>
      </div>
    </form>
  </mat-card>
</div>


